import React from "react";
import styles from "../styles/styles";
import { getCategoryColor } from "../util/categoryColor";
import { TIPO_TREM_FALLBACK, getDoorNumbers } from "../util/doorLayout";
export default function DoorsMatrix({

    cars = [],
    categoryLabel = "Portas",
    topLabels = [],
    bottomLabels = [],
    matrixData = {},
    tipoTrem = TIPO_TREM_FALLBACK

}) {

    return (
        <div style={styles.doorsWrapper}>

            <table style={styles.pantographTable}>

                <thead>
                    <tr>

                        <th style={{ width: "40px" }}></th>

                        <th style={{ width: "180px" }}></th>

                        {cars.map(car => (

                            <th
                                key={car}
                                style={styles.doorsHeader}
                            >
                                Carro {car}
                            </th>

                        ))}

                    </tr>
                </thead>

                <tbody>
                    <tr>

                        {/* CATEGORIA */}
                        <td style={styles.doorsVertical}>
                            {categoryLabel}
                        </td>

                        {/* LABELS */}
                        <td style={styles.doorsLabelsColumn}>

                            <div style={styles.doorsLabelsGrid}>

                                {topLabels.map(label => (
                                    <div key={label} style={styles.doorsLabel}>
                                        {label}
                                    </div>
                                ))}

                            </div>

                            <div style={styles.doorsSpacer}></div>

                            <div style={styles.doorsLabelsGrid}>

                                {bottomLabels.map(label => (
                                    <div key={label} style={styles.doorsLabel}>
                                        {label}
                                    </div>
                                ))}

                            </div>

                        </td>

                        {/* CARROS */}
                        {cars.map(car => (

                            <td
                                key={car}
                                style={styles.doorsCell}
                            >

                                <div style={styles.doorsStack}>

                                    <div
                                        style={{
                                            ...styles.doorsBox,
                                            background:
                                                matrixData?.[car]?.disjuntorAberto
                                                    ? (
                                                        getCategoryColor(
                                                            matrixData?.[car]?.disjuntorAbertoCategory
                                                        ) || "#ef4444"
                                                    )
                                                    : "#fff",
                                            color:
                                                matrixData?.[car]?.disjuntorAberto
                                                    ? "#fff"
                                                    : '#000'
                                        }}
                                    >
                                        DISJUNTOR ABERTO
                                    </div>

                                    <Grid
                                        type="top"
                                        activeIndexes={
                                            matrixData?.[car]?.top ?? []
                                        }
                                        categories={
                                            matrixData?.[car]?.topCategory ?? {}
                                        }
                                    />

                                    <DoorLayout
                                        car={car}
                                        tipoTrem={tipoTrem}
                                        doors={
                                            matrixData?.[car]?.portas ?? []
                                        }
                                    />

                                    <Grid
                                        type="bottom"
                                        activeIndexes={
                                            matrixData?.[car]?.bottom ?? []
                                        }
                                        categories={
                                            matrixData?.[car]?.bottomCategory ?? {}
                                        }
                                    />

                                </div>

                            </td>

                        ))}

                    </tr>
                </tbody>

            </table>

        </div>
    );
}

function Grid({
    type,
    activeIndexes = [],
    categories = {}
}) {

    const isDoorState = (index) => {
        if (type === "top") {
            // Aberta e Fechada (12~19)
            return index >= 12;
        }

        // Fechada e Aberta (0~7)
        return index < 8;
    };


    return (
        <div style={styles.doorsGrid}>

            {Array.from({ length: 20 }).map((_, i) => (

                <div
                    key={i}

                    style={{
                        ...styles.doorsSquare,

                        background:
                            activeIndexes.includes(i)
                                ? (
                                    isDoorState(i)
                                        ? "#967ADD"
                                        : (
                                            getCategoryColor(categories[i]) || "#ef4444"
                                        )
                                )
                                : "#ffffff",
                    }}
                />

            ))}

        </div>
    );
}
function DoorLayout({
    car,
    doors = [],
    tipoTrem = TIPO_TREM_FALLBACK
}) {
    const DOOR_COLOR = "#967ADD";

    const { top, bottom } = getDoorNumbers(car, tipoTrem);

    return (
        <div style={styles.doorsDoorBox}>

            <div style={styles.doorsDoorTop}>

                {top.map(n => (

                    <span
                        key={n}
                        style={{
                            color:
                                doors[n - 1]
                                    ? DOOR_COLOR
                                    : "#111827",

                            fontWeight:
                                doors[n - 1]
                                    ? "700"
                                    : "400"
                        }}
                    >
                        {n}
                    </span>

                ))}

            </div>

            <div style={styles.doorsDoorBottom}>

                {bottom.map(n => (

                    <span
                        key={n}
                        style={{
                            color:
                                doors[n - 1]
                                    ? DOOR_COLOR
                                    : "#111827",

                            fontWeight:
                                doors[n - 1]
                                    ? "700"
                                    : "400"
                        }}
                    >
                        {n}
                    </span>

                ))}

            </div>

        </div>
    );
}
